import { Route } from 'react-router-dom';

import { TabBarRoutes } from '@/features/tabs';
import { UpgradableTickets } from '@/features/ticket-upgrade';

export const AppRoutes = () => {
  return (
    <>
      <Route path="/:tab(guide|my-visit|map|buy)" render={() => <TabBarRoutes />} />
      <Route path="/ticket-to-pass/upgrades" render={() => <UpgradableTickets />} />
    </>
  );
};
